import moment from 'moment';

export const mapSurveyImageFromApiModel = ({
  id,
  relationships: {
    entities: { data = [] },
  },
  attributes: { display_name, created_at, url, width, height },
}) => ({
  id,
  url,
  width,
  height,
  name: display_name,
  createDate: moment(created_at).format('MM/DD/YYYY h:mm A'),
  usageCount: data.length,
});

export const mapSurveyImageListFromApiModel = response => {
  const {
    data,
    meta: { count: totalCount },
    links,
  } = response;
  const images = data.map(mapSurveyImageFromApiModel);

  return {
    images,
    totalCount,
    links,
  };
};
